/* O5b/K3a · "How drills work", as a permanent page.
 *
 * The same four sentences the first-drill tutorial (N4a) shows exactly once.
 * That is the point rather than a duplication: a first-encounter explainer
 * has to disappear — anything still on screen on someone's tenth session
 * fails H3 — and the cost of that rule is that whoever dismissed it, or
 * skipped it, has no way back. The Help section inside the one settings
 * surface is the way back.
 *
 * Shares its copy with FirstTime's rendering of the same keys
 * (locales/en.js#firstTime.drill), so the tutorial and the reference cannot
 * drift into saying different things about the same mechanic.
 */
import { C, PRIMARY } from "../theme.js";
import { Sheet } from "../Sheet.jsx";

export default function DrillHelp({ translate, onClose, mobile }) {
  const rows = ["walkthrough", "quiz", "miss", "hints"];
  return (
    <Sheet title={translate("firstTime.drill.title")} onClose={onClose} mobile={mobile}>
      <div data-testid="drill-help-sheet">
        {rows.map((row) => (
          <div
            key={row}
            style={{ borderTop: `1px solid ${C.faint}`, color: C.ink, fontSize: 13, lineHeight: 1.6, padding: "10px 0" }}
          >
            {translate(`firstTime.drill.${row}`)}
          </div>
        ))}
      </div>
      <button
        onClick={onClose}
        style={{ ...PRIMARY, marginBottom: 4, marginTop: 14, width: "100%" }}
      >
        {translate("firstTime.drill.close")}
      </button>
    </Sheet>
  );
}
